// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-components-studio-arenas-GridFramesLayout-module__root-D758Hm","rowLabel":"src-wab-client-components-studio-arenas-GridFramesLayout-module__rowLabel-K_gMGh","rowLabelInner":"src-wab-client-components-studio-arenas-GridFramesLayout-module__rowLabelInner-e2vvOk"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-components-studio-arenas-GridFramesLayout-module__root-D758Hm\",\"rowLabel\":\"src-wab-client-components-studio-arenas-GridFramesLayout-module__rowLabel-K_gMGh\",\"rowLabelInner\":\"src-wab-client-components-studio-arenas-GridFramesLayout-module__rowLabelInner-e2vvOk\"}";
        // 1793541991372
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  